var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserClub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(892 2322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-892 -2322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1477 -2525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(587 205)",
    fill: "#c2c4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,2A11,11,0,0,0,5.222,20.778,11,11,0,1,0,20.778,5.222,10.928,10.928,0,0,0,13,2m0-2A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z",
    transform: "translate(587 205)",
    fill: "#090d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.444,1095.2v-1.6a2.368,2.368,0,0,0-2.333-2.4h-6.222a2.368,2.368,0,0,0-2.333,2.4v1.6a.778.778,0,1,1-1.555,0v-1.6a3.946,3.946,0,0,1,3.889-4h6.222a3.946,3.946,0,0,1,3.889,4v1.6a.778.778,0,1,1-1.556,0Zm-9.333-11.2a3.89,3.89,0,1,1,3.889,4A3.946,3.946,0,0,1,1325.111,1084Zm1.555,0a2.334,2.334,0,1,0,2.334-2.4A2.368,2.368,0,0,0,1326.666,1084Z",
    transform: "translate(-729 -871)",
    fill: "#090d3d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClub);
export default __webpack_public_path__ + "static/media/user-club.6b3304ada01efc4020d3eda278058327.svg";
export { ForwardRef as ReactComponent };